var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "waba-supsis-message-template-status-update" },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v(
          _vm._s(
            _vm.$t("auto.whatsappBusinessApiV2MessageTemplateStatusUpdated")
          )
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "meta" }, [
        _vm.$_.get(_vm.activity, "payload.originalEvent")
          ? _c("div", [
              _c("b", [_vm._v(_vm._s(_vm.$t("auto.status")))]),
              _vm._v(": "),
              _c(
                "span",
                {
                  class: _vm.getStatusClass(
                    _vm.$_.get(_vm.activity, "payload.originalEvent")
                  ),
                },
                [
                  _vm._v(
                    _vm._s(_vm.$_.get(_vm.activity, "payload.originalEvent"))
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v(_vm._s(_vm.$t("auto.channelId")))]),
          _vm._v(": " + _vm._s(_vm.$_.get(_vm.activity, "payload.channelId"))),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v(_vm._s(_vm.$t("auto.templateName")))]),
          _vm._v(
            ": " +
              _vm._s(_vm.$_.get(_vm.activity, "payload.message_template_name"))
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v(_vm._s(_vm.$t("auto.templateId")))]),
          _vm._v(
            ": " +
              _vm._s(_vm.$_.get(_vm.activity, "payload.message_template_id"))
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v(_vm._s(_vm.$t("auto.language")))]),
          _vm._v(
            ": " +
              _vm._s(
                _vm.$_.get(_vm.activity, "payload.message_template_language")
              )
          ),
        ]),
        _vm._v(" "),
        _vm.$_.get(_vm.activity, "payload.message_template_category")
          ? _c("div", [
              _c("b", [_vm._v(_vm._s(_vm.$t("auto.category")))]),
              _vm._v(
                ": " +
                  _vm._s(
                    _vm.$_.get(
                      _vm.activity,
                      "payload.message_template_category"
                    )
                  ) +
                  "\n        "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$_.get(_vm.activity, "payload.reason") &&
        _vm.$_.get(_vm.activity, "payload.reason") !== "NONE"
          ? _c("div", [
              _c("b", [_vm._v(_vm._s(_vm.$t("auto.reason")))]),
              _vm._v(
                ": " +
                  _vm._s(_vm.$_.get(_vm.activity, "payload.reason")) +
                  "\n        "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$_.get(_vm.activity, "payload.previous_quality_score")
          ? _c("div", [
              _c("b", [_vm._v(_vm._s(_vm.$t("auto.previousQualityScore")))]),
              _vm._v(": "),
              _c(
                "span",
                {
                  class: _vm.getQualityClass(
                    _vm.$_.get(_vm.activity, "payload.previous_quality_score")
                  ),
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$_.get(_vm.activity, "payload.previous_quality_score")
                    )
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$_.get(_vm.activity, "payload.new_quality_score")
          ? _c("div", [
              _c("b", [_vm._v(_vm._s(_vm.$t("auto.newQualityScore")))]),
              _vm._v(": "),
              _c(
                "span",
                {
                  class: _vm.getQualityClass(
                    _vm.$_.get(_vm.activity, "payload.new_quality_score")
                  ),
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$_.get(_vm.activity, "payload.new_quality_score")
                    )
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("details", { staticClass: "raw" }, [
        _c("summary", [_vm._v(_vm._s(_vm.$t("auto.rawPayload")))]),
        _vm._v(" "),
        _c("pre", [_vm._v(_vm._s(_vm.prettyPayload))]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }